import React from 'react'
import Form from "../common/form/Form";
import { Link } from 'react-router-dom';


export default function AuthFormMain(props) {
    return (<Form validate={true} onSubmit={props.onCodeRequest}>
        <div className='auth_inputs'>
            {props.renderFields(props.fieldsAuth, 'fieldsAuth')}
        </div>
        <p className="recovery-link auth__link">
            <Link to="/recovery">{props.translate("Забыли пароль?")}</Link>
        </p>
        {props.errorUserNotFound && <span className="text-error reg auth">{props.errorUserNotFound}</span>}
        <button type='submit'
            className={"btn_auth reg" + (props.isValid('fieldsAuth') && !props.sendRequest && props.numberValue && props.passwordValue ? "" : " disabled")}
        >
            Войти
        </button>
    </Form>);
}